module.exports = __webpack_public_path__ + "img/warningBlue.e9621583.svg";